/*校验是否中文名称组成 */

export function IsName (that,val,hit) {
    var reg = /^[\u4E00-\u9FA5]{2,4}$/;  /*定义验证表达式*/
    if(val==''){
        console.log(hit+'不能为空')
        that.wUserName=hit+"不能为空"
        return false
    }else if(val.length<3) {

        that.wUserName=hit+'不符合规范'
        return false

    }
    console.log(reg.test(val))
    that.wUserName=''
    return true;   /*进行验证*/
}

export function IsCreditCode (that,val,hit) {
    var reg = /^[\u4E00-\u9FA5]{2,4}$/; 
    if(val==''){
        console.log(hit+'不能为空')
        that.wCreditCode=hit+"不能为空"
        return false
    }else if(val.length<18) {

        that.wCreditCode=hit+'不符合规范'
        return false

    }
    //console.log(reg.test(val))
    that.wCreditCode=''
    return true; 
}
/*登录密码校验 */

export function IsPaw (that,val,hit) {
    var reg = /^[\u4E00-\u9FA5]{2,4}$/;  /*定义验证表达式*/
    if(val==''){
        console.log(hit+'不能为空')
        that.wPaw=hit+"不能为空"

        return false
    }else if(val.length<6) {
        console.log('不符合规范')
        that.wPaw='登录密码至少6位数'

        return false

    }
    console.log(reg.test(val))
    that.wPaw=''
    return true;   /*进行验证*/
}
/*验证码校验 */

export function IsCode(that,val,hit) {
    var reg = /^\d{6}$/;  /*定义验证表达式*/
    if(val==''){
        console.log(hit+'不能为空')
        that.wCode=hit+"不能为空"

        return false
    }else if(!reg.test(val)) {
        console.log('不符合规范')
        that.wCode=hit+'不符合规范'

        return false

    }
    console.log(reg.test(val))
    that.wCode=''
    return true;   /*进行验证*/
}
export function IsCode2(that,val,hit) {
    var reg = /^\d{6}$/;  /*定义验证表达式*/
    if(val==''){
        console.log(hit+'不能为空')
        that.newPhoneData.wCode=hit+"不能为空"

        return false
    }else if(!reg.test(val)) {
        console.log('不符合规范')
        that.newPhoneData.wCode=hit+'不符合规范'

        return false

    }
    console.log(reg.test(val))
    that.newPhoneData.wCode=''
    return true;   /*进行验证*/
}
/*确认密码校验 */

export function IsPawCompare(that,val,hit,newVal) {
    var reg = /^\d{6}$/;  /*定义验证表达式*/
    if(val==''){
        console.log(hit+'不能为空')
        that.wNewPaw=hit+"不能为空"

        return false
    }else if(newVal!==val) {

        that.wNewPaw='两次密码不一致'

        return false

    }
    console.log(reg.test(val))
    that.wNewPaw=''
    return true;   /*进行验证*/
}
/*电子邮箱校验 */

export function IsEmail(that,val,hit) {
    var reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;  /*定义验证表达式*/
    if(val==''){
        console.log(hit+'不能为空')
        that.wEmail=hit+"不能为空"

        return false
    }else if(!reg.test(val)) {
        console.log('不符合规范')
        that.wEmail=hit+'不符合规范'

        return false

    }
    console.log(reg.test(val))
    that.wEmail=''
    return true;   /*进行验证*/
}
/*手机号校验 */

export function IsTel(that,val,hit) {
    var reg =/^1[123456789]\d{9}$/;  /*定义验证表达式*/
    if(val==''){
        console.log(hit+'不能为空')
        that.wTel=hit+"不能为空"

        return false
    }else if(!reg.test(val)) {
        console.log('不符合规范')
        that.wTel=hit+'不符合规范'

        return false

    }
    console.log(reg.test(val))
    that.wTel=''
    return true;   /*进行验证*/
}
export function IsTel2(that,val,hit) {
    var reg =/^1[123456789]\d{9}$/;  /*定义验证表达式*/
    if(val==''){
        console.log(hit+'不能为空')
        that.newPhoneData.wPaw=hit+"不能为空"
        return false
    }else if(!reg.test(val)) {
        console.log('不符合规范')
        that.newPhoneData.wPaw=hit+'不符合规范'
        return false
    }
    console.log(reg.test(val))
    that.newPhoneData.wPaw=''
    return true;   /*进行验证*/
}
